module.exports = __webpack_public_path__ + "media/images/lb/014-3185e0bf40014fbb57bf72aad864ccb0.svg";